import Vue from 'vue'
import App from './App.vue'
import routes from '@/routes.js'

// dependencies
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import store from '@/store'

// use
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(mavonEditor)

const router = new VueRouter(routes)

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let isLoggedIn = store.state.isLoggedIn;
    if (!isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  }
});

// config
Vue.config.productionTip = false

new Vue({
  router: router,
  store,
  el: '#app',
  render: h => h(App)
}).$mount('#app')

export { router };
